import { KeyboardArrowRightTwoTone } from '@mui/icons-material';
import { ListItemButton, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';

type OrderItemProps = {
  number: string;
  tourName: string;
  tourStartDate: string;
  tourEndDate: string;
  salesIndividualId: string;
  customerLastName?: string;
  orderNumber?: string;
  tourId?: number;
};

export function OrderItem(props: OrderItemProps) {
  const endDate = new Date(props.tourEndDate);
  const now = new Date();
  const diffMs = now.getTime() - endDate.getTime();
  const fourteenDaysInMs = 14 * 24 * 60 * 60 * 1000;
  const isAfter14Days = diffMs >= fourteenDaysInMs;

  return (
    <div>
      {isAfter14Days ? (
        <ListItemButton
          component={Link}
          to={`${props.salesIndividualId}/invoice?lastName=${props.customerLastName}&orderNumber=${props.orderNumber}&tourId=${props.tourId}`}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <ListItemText
            primary={props.tourName}
            secondary={`${props.tourStartDate} - #${props.number}`}
          />
          <KeyboardArrowRightTwoTone />
        </ListItemButton>
      ) : (
        <Link
          to={`/account/orders/${props.salesIndividualId}`}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <ListItemButton>
            <ListItemText
              primary={props.tourName}
              secondary={`${props.tourStartDate} - #${props.number}`}
            />
            <KeyboardArrowRightTwoTone />
          </ListItemButton>
        </Link>
      )}
    </div>
  );
}
